export const PAGE_SIZES = [ 50, 100, 200, 500 ];